const api = require('../infrastructure/api');

const EVENTS_URL = '/events';

async function createEvent(event) {
  const url = EVENTS_URL;
  const payload = {
    data: {
      type: 'events',
      attributes: {
        aggregateId: event.data.attributes.id,
        aggregateVersion: 1,
        type: event.data.type,
        data: event.data.attributes,
        metadata: event.metadata
      }
    }
  };
  const result = await api.post(url, payload).then(response => {
    return response.data;
  });
  return result;
}

module.exports = {
  createEvent
};
